export const PRODUCT_TABLE = "products"
export const PRODUCT_TABLE_SCHEMA =
  "id, companyId, sku, code, isSleeping, syncId"
